var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.95a.8.8 0 01.8.8v3.75a.8.8 0 01-1.6 0V9.75a.8.8 0 01.8-.8zM13 16.75a1 1 0 11-2 0 1 1 0 012 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.851 2.508a2.3 2.3 0 013.14.84l8.247 14.25a2.3 2.3 0 01-1.99 3.451H3.752a2.3 2.3 0 01-1.99-3.452l8.247-14.25a2.3 2.3 0 01.842-.84zM12 3.8a.7.7 0 00-.606.35L3.146 18.398a.7.7 0 00.606 1.05h16.496a.7.7 0 00.606-1.05l-8.248-14.25A.7.7 0 0012 3.8z",
    fillRule: "evenodd"
  }))));
}

export default SvgWarning;